/* import __COLOCATED_TEMPLATE__ from './dropped-recipient.hbs'; */
/* RESPONSIBLE TEAM: team-channels */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: {
    displayText: string | undefined;
    dropReason: string;
    dropReasonTexts: Record<string, string>;
    defaultDropReasonText: string;
    learnMoreUrl: string;
  };
}

const DroppedRecipient = templateOnlyComponent<Signature>();
export default DroppedRecipient;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationStream::PartGroups::DroppedRecipient': typeof DroppedRecipient;
    'inbox2/conversation-stream/part-groups/dropped-recipient': typeof DroppedRecipient;
  }
}
